export default "__VITE_ASSET__DDCCzjLA__"